export default "__VITE_ASSET__55314c95__"